import React from "react";
import { Field, ErrorMessage } from "formik";

const RadioField = ({
    label,
    name,
    options = [],
    color = "bg-white",
    labelColor = "",
    fontWeight = "font-normal",
    direction = "row", // "row" or "col"
    disabled = false,
    ...props
}) => {
    return (
        <div className={`${color} flex flex-col mb-2`}>
            <div className={`${label ? "flex justify-between" : ""}`}>
                {label && (
                    <label
                        className={`${fontWeight} ${labelColor} block text-start mb-2`}
                    >
                        {label}
                    </label>
                )}
                <ErrorMessage
                    name={name}
                    component="div"
                    className="text-sm text-red-500 mt-1"
                />
            </div>

            <Field name={name}>
                {({ field }) => (
                    <div className={`flex flex-${direction} gap-4`}>
                        {options.map((option) => (
                            <label
                                key={option.value}
                                className="inline-flex items-center space-x-2 text-sm"
                            >
                                <input
                                    type="radio"
                                    {...field}
                                    value={option.value}
                                    checked={field.value === option.value}
                                    disabled={disabled}
                                    className="form-radio text-blue-600 focus:ring-blue-500"
                                    {...props}
                                />
                                <span>{option.label}</span>
                            </label>
                        ))}
                    </div>
                )}
            </Field>
        </div>
    );
};

export default RadioField;
